import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./Page/Login";
import Initialize from "./Page/Initialize";
import RequestList from "./Page/RequestList";
import RequestDetail from "./Page/RequestDetail";
// import RequestSupport from "./Page/RequestSupport";
import ProjectList from "./Page/ProjectList";
import HomePageEdit from "./Page/HomePageEdit";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="/initialize" element={<Initialize />} />
        <Route path="/request_list" element={<RequestList />} />
        <Route path="/request_details/" element={<RequestDetail />} />
        {/* <Route path="/request_support" element={<RequestSupport />} /> */}
        <Route path="/project_list" element={<ProjectList />} />
        <Route path="/home_page_edit" element={<HomePageEdit />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
